export default {
  user: {},
  loginUserToken: '',
  customerQuotation: {},
  tempQuotationPayment: false,
  sessionResponseData: {},
  prePaymentData: {},
  signupRedirect: false
}



// WEBPACK FOOTER //
// ./src/store/modules/state.js